import { Col, Row } from 'antd';
import React from 'react';
import Title from 'antd/es/typography/Title';
import { FinancialOverviewInfoProvider } from './hooks/useCurrentFinancialOverview';
import FinancialOverviewTable from './Components/FinancialOverviewTable';

const FinancialOverviewView = () => {
    return (
        <>
            <Row style={{ paddingBottom: 10, paddingTop: 10 }}>
                <Col span={12}>
                    <Title level={3}>Financial Overview</Title>
                </Col>
            </Row>
            <div style={{ flex: '1 1 auto' }}>
                <FinancialOverviewInfoProvider>
                    <FinancialOverviewTable />
                </FinancialOverviewInfoProvider>
            </div>
        </>
    );
};
export default FinancialOverviewView;
